// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_xpo-ltl_ngx-shell_fesm2020_xpo-ltl-ngx-shell_mjs":"a1901c3c8d225b1f","src_app_screens_invalid-permissions_invalid-permissions_component_ts":"b40752bcf8f2f251","src_app_screens_rfp-root_rfp-root_component_ts":"68cd8c26a860041d"}[chunkId] + ".js";
};